import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ApiService from '../../services/api.service';
import LoginLayout from '../../components/LoginLayout';

const inputStyle = {
  width: '100%',
  height: '42px',
  padding: '0 14px',
  fontSize: '0.9rem',
  color: '#1a1a1a',
  backgroundColor: '#f8f9fa',
  border: '1px solid #ddd',
  borderRadius: '8px',
  outline: 'none',
  transition: 'border-color 0.15s',
  colorScheme: 'light',
  WebkitAppearance: 'none',
};

const GroupLogin = ({ onGroupLogin }) => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await ApiService.groupLogin(username, password);

      if (response.data && response.data.success) {
        const data = response.data.data;
        const user = data.user;
        const token = data.token;

        localStorage.setItem('groupToken', token);
        localStorage.setItem('groupUser', JSON.stringify(user));
        localStorage.setItem('groupData', JSON.stringify(data.group || null));

        onGroupLogin(user);
        navigate('/group/dashboard');
      }
    } catch (err) {
      console.error('Group login failed:', err);
      const errorMessage = err.response?.data?.message || 'Invalid credentials. Please try again.';
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <LoginLayout
      title="Owner Login"
      subtitle="Access all your typing centers in one place"
      footerLink={{ text: "Typing Center Staff? Login here", href: "/login" }}
    >
      <div style={{
        width: '100%',
        backgroundColor: '#ffffff',
        borderRadius: '12px',
        boxShadow: '0 4px 24px rgba(0,0,0,0.12)',
        padding: '28px 28px 32px',
        colorScheme: 'light',
      }}>
        <h2 style={{ fontSize: '1.1rem', fontWeight: 600, color: '#1a1a1a', marginBottom: '20px' }}>
          Sign In
        </h2>

        {error && (
          <div style={{
            padding: '10px 14px', marginBottom: '16px', borderRadius: '8px',
            backgroundColor: '#fef2f2', border: '1px solid #fecaca', color: '#b91c1c', fontSize: '0.85rem',
          }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: 500, color: '#555', marginBottom: '6px' }}>
              Username
            </label>
            <input
              type="text"
              placeholder="Enter your username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              style={inputStyle}
              onFocus={(e) => e.target.style.borderColor = '#999'}
              onBlur={(e) => e.target.style.borderColor = '#ddd'}
            />
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: 500, color: '#555', marginBottom: '6px' }}>
              Password
            </label>
            <input
              type="password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={inputStyle}
              onFocus={(e) => e.target.style.borderColor = '#999'}
              onBlur={(e) => e.target.style.borderColor = '#ddd'}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              height: '44px',
              fontSize: '0.85rem',
              fontWeight: 600,
              letterSpacing: '0.08em',
              textTransform: 'uppercase',
              color: '#ffffff',
              backgroundColor: loading ? '#999' : '#1a1a1a',
              border: 'none',
              borderRadius: '8px',
              cursor: loading ? 'not-allowed' : 'pointer',
              transition: 'background-color 0.15s',
            }}
            onMouseEnter={(e) => { if (!loading) e.target.style.backgroundColor = '#333'; }}
            onMouseLeave={(e) => { if (!loading) e.target.style.backgroundColor = '#1a1a1a'; }}
          >
            {loading ? 'Signing in...' : 'Login'}
          </button>
        </form>
      </div>
    </LoginLayout>
  );
};

export default GroupLogin;
